import { AdminLayout } from 'apps/sigma2-ui/src/components/AdminLayout';
import { useParams } from 'react-router';
import { useMemo } from 'react';
import React from 'react';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';
import { Button } from 'apps/sigma2-ui/src/components/ui/Button';
import { DatabaseRubricBankConstructsView } from 'apps/sigma2-ui/src/data-wizard/components/DatabaseRubricBankConstructsView';
import { useRubricConstructsData } from 'apps/sigma2-ui/src/data-wizard/components/use-rubric-constructs-data';
import { AdminBreadcrumbs } from 'apps/sigma2-ui/src/components/ui/AdminBreadcrumbs';

export const DatabaseRubricBankPage = () => {
  const { organizationId, databaseId } = useParams();

  if (!organizationId || !databaseId) {
    throw new Error(
      'DatabaseRubricBankPage: organizationId or databaseId is not defined',
    );
  }

  const useRubricBankConstructsPayload = useRubricConstructsData({
    organizationId,
    databaseId,
    isSelectEnabled: false,
  });

  const isLoading = useMemo(() => {
    return (
      useRubricBankConstructsPayload.readPattern.status === 'loading' ||
      useRubricBankConstructsPayload.createConstructPattern.status === 'saving'
    );
  }, [useRubricBankConstructsPayload]);

  return (
    <AdminLayout currentPage={'DatabaseRubricBank'}>
      <AdminBreadcrumbs
        items={[
          { label: 'Home', to: '/admin' },
          { label: 'Organizations', to: '/organizations' },
          {
            label: 'Databases',
            to: `/organizations/${organizationId}/databases`,
          },
          {
            label: 'Edit Database',
            to: `/organizations/${organizationId}/databases/edit/${databaseId}`,
          },
          {
            label: 'Rubric Bank',
            to: `/organizations/${organizationId}/databases/${databaseId}/rubric-bank`,
          },
        ]}
      />
      <Spacing size={'md'} direction={'vertical'}>
        <Spacing size={'lg'} direction={'horizontal'}>
          <Button
            behavior={{
              type: 'onClick',
              onClick: () => {
                if (
                  useRubricBankConstructsPayload.createConstructPattern
                    .status === 'saving'
                ) {
                  return;
                }

                useRubricBankConstructsPayload.createConstructPattern.saveEntity(
                  {
                    name: 'New Construct',
                    createdAt: Date.now(),
                    updatedAt: null,
                    createdBy: 'Me',
                    items: [],
                  },
                  () => {
                    if (
                      useRubricBankConstructsPayload.readPattern.status !==
                      'loading'
                    ) {
                      useRubricBankConstructsPayload.readPattern.reloadEntity();
                    }
                  },
                );
              },
            }}
            size={'small'}
            disabled={isLoading}
            variant={'primary'}
            text={'Create New Construct'}
          />

          <Button
            behavior={{
              type: 'href',
              href: `/organizations/${organizationId}/databases/${databaseId}/rubric-bank-items`,
            }}
            size={'small'}
            disabled={isLoading}
            variant={'primary'}
            text={'View Items'}
          />
        </Spacing>

        <DatabaseRubricBankConstructsView
          payload={useRubricBankConstructsPayload}
          isEditable={true}
        />
      </Spacing>
    </AdminLayout>
  );
};
